import { render, staticRenderFns } from "./check_mode.vue?vue&type=template&id=2f6b2d44&scoped=true"
import script from "./check_mode.vue?vue&type=script&lang=js"
export * from "./check_mode.vue?vue&type=script&lang=js"
import style0 from "./check_mode.vue?vue&type=style&index=0&id=2f6b2d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6b2d44",
  null
  
)

export default component.exports